(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-archive"] && !Shopify.designMode) return;
  try {
    
  const syncDropArchive = (scope = document) => {
    const heroLink = scope.querySelector('.drop-hero__submit') || document.querySelector('.drop-hero__submit')
    const productName = scope.querySelector('.drop-hero__product-name') || document.querySelector('.drop-hero__product-name')
    document.querySelectorAll('[data-drop-archive-link]').forEach((archiveLink) => {
      if (heroLink) archiveLink.href = heroLink.href
      const archiveTitle = archiveLink.querySelector('[data-drop-archive-title]')
      if (archiveTitle && productName) archiveTitle.textContent = productName.textContent.trim()
    })
  }
  syncDropArchive()
  document.addEventListener('shopify:section:load', (event) => syncDropArchive(event.target))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeDrop = (root) => {
    if (root.dataset.dropInitialized === 'true') return
    root.dataset.dropInitialized = 'true'
    const sticky = root.querySelector('[data-drop-sticky]')
    if (sticky) {
      const observer = new IntersectionObserver((entries) => sticky.classList.toggle('is-visible', entries[0].isIntersecting))
      observer.observe(root)
    }
  }
  const initializeAllDrops = (scope = document) => scope.querySelectorAll('[data-drop-root]').forEach(initializeDrop)
  initializeAllDrops()
  document.addEventListener('shopify:section:load', (event) => initializeAllDrops(event.target))
  document.addEventListener('grs:release-updated', () => initializeAllDrops())

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-product"] && !Shopify.designMode) return;
  try {
    
  const initializeDropProduct = (root) => {
    if (root.dataset.productInitialized === 'true') return
    root.dataset.productInitialized = 'true'
    const data = root.querySelector('[data-product-variants]')
    if (!data || !root.querySelector('[data-add-button]')) return
    const variants = JSON.parse(data.textContent)
    const groups = [...root.querySelectorAll('[data-product-option]')]
    const variantInput = root.querySelector('[data-variant-id]')
    const price = root.querySelector('[data-product-price]')
    const selectedTitle = root.querySelector('[data-selected-variant]')
    const selectedStock = root.querySelector('[data-selected-stock-copy]')
    const addButton = root.querySelector('[data-add-button]')
    const addLabel = root.querySelector('[data-add-label]')

    const selections = () => groups.map((group) => group.querySelector('input:checked')?.value)
    const matchingVariant = (options) => variants.find((variant) => variant.options.every((value, index) => value === options[index]))
    const stockCopy = (remaining) => remaining === null ? root.dataset.untrackedStock : root.dataset.remainingTemplate.replace('__COUNT__', remaining)

    const updateOptionStates = (selectedOptions) => {
      groups.forEach((group, groupIndex) => {
        group.querySelectorAll('input').forEach((input) => {
          const candidate = [...selectedOptions]
          candidate[groupIndex] = input.value
          const variant = matchingVariant(candidate)
          const colorAvailable = group.hasAttribute('data-color-option') && variants.some(item => item.options[groupIndex] === input.value && item.available)
          input.disabled = !colorAvailable && (!variant || !variant.available)
          const stock = input.nextElementSibling?.querySelector('[data-option-stock]')
          if (stock) stock.textContent = variant ? stockCopy(variant.remaining) : '—'
        })
      })
    }

    const update = () => {
      const selectedOptions = selections()
      const variant = groups.length ? matchingVariant(selectedOptions) : variants.find((item) => String(item.id) === variantInput.value)
      updateOptionStates(selectedOptions)
      if (!variant) {
        addButton.disabled = true
        addLabel.textContent = root.dataset.soldLabel
        return
      }
      variantInput.value = variant.id
      price.textContent = variant.price
      selectedTitle.textContent = variant.title
      selectedStock.textContent = stockCopy(variant.remaining)
      const gallery = root.querySelector('.drop-product__media')
      const targetMedia = gallery?.querySelector(`[data-media-id="${variant.media_id}"]`)
      if (targetMedia && !targetMedia.classList.contains('drop-product__media-item--lead')) {
        gallery.querySelectorAll('.drop-product__media-item').forEach((item) => {
          item.classList.toggle('drop-product__media-item--lead', item === targetMedia)
          item.querySelectorAll('video').forEach((video) => video.pause())
        })
        gallery.scrollLeft = 0
      }
      const purchaseReady = root.dataset.purchaseReady === 'true'
      addButton.disabled = !variant.available || !purchaseReady
      addLabel.textContent = !purchaseReady ? root.dataset.setupLabel : variant.available ? root.dataset.addLabel : root.dataset.soldLabel
      const url = new URL(window.location.href)
      url.searchParams.set('variant', variant.id)
      window.history.replaceState({}, '', url)
      const colorIndex = groups.findIndex(group => group.hasAttribute('data-color-option'))
      if (colorIndex >= 0) document.dispatchEvent(new CustomEvent('grs:variant-changed', {detail: {color: variant.options[colorIndex]}}))
    }

    groups.forEach((group, index) => group.addEventListener('change', () => {
      if (group.hasAttribute('data-color-option')) {
        const options = selections()
        const current = matchingVariant(options)
        if (!current?.available) {
          const fallback = variants.find(item => item.options[index] === options[index] && item.available)
          if (fallback) groups.forEach((other, optionIndex) => {
            other.querySelectorAll('input').forEach(input => { input.checked = input.value === fallback.options[optionIndex] })
          })
        }
      }
      update()
    }))
    update()
  }

  const initializeAllDropProducts = (scope = document) => scope.querySelectorAll('[data-drop-product]').forEach(initializeDropProduct)
  initializeAllDropProducts()
  document.addEventListener('shopify:section:load', (event) => initializeAllDropProducts(event.target))
  document.addEventListener('grs:release-updated', () => initializeAllDropProducts())

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-related-colors"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('grs:variant-changed', event => {
    document.querySelectorAll('[data-related-color]').forEach(card => {
      card.hidden = card.dataset.relatedColor === event.detail.color
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
